import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faArrowRight, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'

import { BaseModal, JobPoUser } from '../../shared'

interface UserItem {
    id: number
    name: string
}

@Component({
    selector: 'app-job-po-add-user',
    templateUrl: './job-po-add-user.component.html',
    standalone: true,
    imports: [CommonModule, FormsModule, FaIconComponent],
})
export class JobPoAddUserComponent extends BaseModal implements OnInit {
    faArrowRight = faArrowRight
    faArrowLeft = faArrowLeft
    faSpinner = faSpinner

    job = ''
    allUsers: UserItem[] = []
    selectedUserHrRefs: number[] = []

    availableUsers: UserItem[] = []
    selectedUsers: UserItem[] = []
    availableSearch = ''
    selectedSearch = ''

    ngOnInit(): void {
        if (!this.selectedUserHrRefs) {
            this.selectedUserHrRefs = []
        }
        this.updateLists()
    }

    updateLists() {
        this.availableUsers = this.allUsers.filter(u => !this.selectedUserHrRefs.includes(u.id))
        this.selectedUsers = this.allUsers.filter(u => this.selectedUserHrRefs.includes(u.id))
        this.filterAvailable()
        this.filterSelected()
    }

    filterAvailable() {
        if (this.availableSearch === '') {
            this.availableUsers = this.allUsers.filter(u => !this.selectedUserHrRefs.includes(u.id))
        } else {
            const searchLower = this.availableSearch.toLowerCase()
            this.availableUsers = this.allUsers.filter(
                u => !this.selectedUserHrRefs.includes(u.id) && u.name.toLowerCase().includes(searchLower),
            )
        }
    }

    filterSelected() {
        if (this.selectedSearch === '') {
            this.selectedUsers = this.allUsers.filter(u => this.selectedUserHrRefs.includes(u.id))
        } else {
            const searchLower = this.selectedSearch.toLowerCase()
            this.selectedUsers = this.allUsers.filter(
                u => this.selectedUserHrRefs.includes(u.id) && u.name.toLowerCase().includes(searchLower),
            )
        }
    }

    moveToSelected(user: UserItem) {
        if (!this.selectedUserHrRefs.includes(user.id)) {
            this.selectedUserHrRefs.push(user.id)
            this.updateLists()
        }
    }

    moveToAvailable(user: UserItem) {
        const index = this.selectedUserHrRefs.indexOf(user.id)
        if (index > -1) {
            this.selectedUserHrRefs.splice(index, 1)
            this.updateLists()
        }
    }

    moveAllToSelected() {
        this.availableUsers.forEach(u => {
            if (!this.selectedUserHrRefs.includes(u.id)) {
                this.selectedUserHrRefs.push(u.id)
            }
        })
        this.updateLists()
    }

    moveAllToAvailable() {
        this.selectedUsers.forEach(u => {
            const index = this.selectedUserHrRefs.indexOf(u.id)
            if (index > -1) {
                this.selectedUserHrRefs.splice(index, 1)
            }
        })
        this.updateLists()
    }

    onAvailableDoubleClick(selectElement: HTMLSelectElement) {
        const val = selectElement.value
        if (val) {
            const user = this.allUsers.find(u => u.id === +val)
            if (user) this.moveToSelected(user)
        }
    }

    onSelectedDoubleClick(selectElement: HTMLSelectElement) {
        const val = selectElement.value
        if (val) {
            const user = this.allUsers.find(u => u.id === +val)
            if (user) this.moveToAvailable(user)
        }
    }

    moveSelectedToRight(selectElement: HTMLSelectElement) {
        const val = selectElement.value
        if (val) {
            const user = this.allUsers.find(u => u.id === +val)
            if (user) this.moveToSelected(user)
        }
    }

    moveSelectedToLeft(selectElement: HTMLSelectElement) {
        const val = selectElement.value
        if (val) {
            const user = this.allUsers.find(u => u.id === +val)
            if (user) this.moveToAvailable(user)
        }
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        this.services.data
            .put<JobPoUser[]>('api/JobPoConfiguration/SyncUsers', {
                job: this.job,
                userHrRefs: this.selectedUserHrRefs,
            })
            .subscribe({
                next: result => resolveSave(result),
                error: errorResult => {
                    this.services.notification.error('Failed to save user assignments')
                    rejectSave(errorResult)
                },
            })
    }
}
